exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logoDucter[data-v-4a65fba8]{max-width:300px;height:auto}.image[data-v-4a65fba8]{display:inline-block}#logo[data-v-4a65fba8]{margin-bottom:30px}@media (min-width:641px) and (orientation:portrait){.column-login[data-v-4a65fba8]{width:30vh;margin-left:20vh}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a65fba8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ducterTube/views/nuevo.vue
// module id = 3938
// module chunks = 0